module.exports = __webpack_public_path__ + "img/D201607_4.32259f49.jpg";